var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m6.17 12.63 3 1.74M3.342 7 12 12m0 0 8.658-4.999M12 12v10m4.33-12.5L7.54 4.27m13.386 11.729V8c0-.715-.381-1.375-1-1.732L13 2.27a2 2 0 0 0-2 0L4.074 6.269a2 2 0 0 0-1 1.732v7.997c0 .715.381 1.375 1 1.732l6.926 4a2 2 0 0 0 2 0l6.926-4a2 2 0 0 0 1-1.731",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgOrders;